import { useEffect, useRef } from 'react';

export const useSearchBodyLock = (locked: boolean) => {
  const lockedScrollYRef = useRef(0);

  useEffect(() => {
    const body = document.body;
    if (!locked) {
      body.classList.remove('no-scroll');
      return undefined;
    }

    lockedScrollYRef.current = window.scrollY;
    const previousStyles = {
      position: body.style.position,
      top: body.style.top,
      left: body.style.left,
      right: body.style.right,
      width: body.style.width,
      overflow: body.style.overflow,
    };

    body.classList.add('no-scroll');
    body.style.position = 'fixed';
    body.style.top = `-${lockedScrollYRef.current}px`;
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    body.style.overflow = 'hidden';

    return () => {
      body.classList.remove('no-scroll');
      body.style.position = previousStyles.position;
      body.style.top = previousStyles.top;
      body.style.left = previousStyles.left;
      body.style.right = previousStyles.right;
      body.style.width = previousStyles.width;
      body.style.overflow = previousStyles.overflow;
      window.scrollTo(0, lockedScrollYRef.current);
    };
  }, [locked]);
};
